import { PageFilter } from '../state/app';
import {
  SampleDevelopmentWlApprovalRequest,
  SampleDevelopmentWlApprovalRequestListFilter,
} from '../state/sampleDevelopmentWlApprovalRequest/sampleDevelopmentWlApprovalRequest.types';
import axios from '../utils/axios';
const baseUrl = `/api/sampleDevelopmentWlApprovalRequests`;

export const fetchSampleDevelopmentWlApprovalRequestList = async ({
  filters,
  paging,
}: {
  filters: SampleDevelopmentWlApprovalRequestListFilter;
  paging: PageFilter;
}) => {
  const params = new URLSearchParams();
  params.append('cacheBuster', new Date().getTime().toString());
  params.append('pageSize', paging.pageSize.toString());
  params.append('pageNumber', paging.pageNumber.toString());

  Object.entries(filters).forEach(([key, value]) => {
    params.append(key, value);
  });

  const requestUrl = `${baseUrl}`;
  return await axios.get(`${requestUrl}?${params.toString()}`);
};

export const updateSampleDevelopmentWlApprovalRequesResponse = async (
  sampleDevelopmentWlApprovalRequest: SampleDevelopmentWlApprovalRequest,
) => {
  const requestUrl = `${baseUrl}/response`;
  return await axios.put(requestUrl, sampleDevelopmentWlApprovalRequest);
};
